import { showErrorNotification, showSuccessNotification } from '@/services/notification-service.ts';

import { getVersion } from '@/utils/env-utils.ts';

interface UseCopyVersionReturn {
    handleCopyVersion: () => Promise<void>;
}

const handleCopyVersion = async (): Promise<void> => {
    try {
        await navigator.clipboard.writeText(getVersion());
        showSuccessNotification('Version kopiert!');
    } catch {
        showErrorNotification('Version konnte nicht kopiert werden.');
    }
};

export const useCopyVersion = (): UseCopyVersionReturn => {
    return { handleCopyVersion: handleCopyVersion };
};
